import type { HTMLAttributes, ReactNode } from "react"
import { useEffect, useRef, useState } from "react"
import { cn } from "@/lib/utils"

export function SectionReveal({
  children,
  className,
  ...props
}: HTMLAttributes<HTMLDivElement> & {
  children: ReactNode
}) {
  const ref = useRef<HTMLDivElement>(null)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (!ref.current || !("IntersectionObserver" in window)) {
      setVisible(true)

      return
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) {
          setVisible(true)
          observer.disconnect()
        }
      },
      { rootMargin: "0px 0px -10% 0px", threshold: 0.08 },
    )

    observer.observe(ref.current)

    return () => observer.disconnect()
  }, [])

  return (
    <div {...props} ref={ref} data-visible={visible} className={cn("section-reveal", className)}>
      {children}
    </div>
  )
}
